import _ from "lodash";

export default class Player {

    constructor(scene, x, y) {
        this.animations = require('../json/animations.json');

        this.scene = scene;

        // Create the animations we need from the loaded sequences
        this.createAnimation(scene, 'start');
        this.createAnimation(scene, 'fall');
        this.createAnimation(scene, 'floss');
        this.createAnimation(scene, 'gangnam');
        this.createAnimation(scene, 'main');
        this.createAnimation(scene, 'shoot');
        this.createAnimation(scene, 'twerk');
        this.createAnimation(scene, 'dab');

        //Create the transition animation
        scene.anims.create({
            key: 'flare',
            frames: [
                {
                    key: 'flare'
                }
            ],
            frameRate: scene.fps,
            repeat: 3
        });

        //Calculate the scale for the transition
        this.flare_scale = Math.min(scene.innerWidth / this.scene.textures.getFrame('flare').width, scene.innerHeight / this.scene.textures.getFrame('flare').height)
        if (scene.bg_scale > this.flare_scale) {
            this.flare_scale = scene.bg_scale;
        }

        // Create the sprite that we will animate
        this.sprite = scene.add.sprite(x, y, "player", 'start_1')

        this.player_scale = scene.bg_scale ? scene.bg_scale : 1;

        if (scene.is_mobile) {
            //We need to double the player scale, because it's in landscape
            this.player_scale = this.player_scale * 2;
        }

        this.sprite.setScale(this.player_scale);

        this.sprite.setPosition(x, y);

        //When the transition animation is completed, play the next animation in line
        this.sprite.on('animationcomplete', (animation, frame) => {
            if (frame.textureKey === 'flare') {
                this.sprite.anims.play(this.sprite.next_animation, true).setScale(this.player_scale);

                this.sprite.setPosition(x, y);
            } else if (frame.textureFrame.indexOf('fall') > -1) {
                this.scene.finishGame();
            }
        });

        this.marked = false;
    }

    /**
     * Start the animation
     */
    start() {
        this.sprite.anims.play('start', true);
    }

    /**
     * Starts the falling animation and stop the animation cycle
     */
    stop() {
        this.marked = true;

        this.nextAnimation('fall');
    }

    /**
     * Creates a new player animation
     *
     * @param scene
     * @param name
     * @param frameCount
     */
    createAnimation(scene, name) {
        scene.anims.create({
            key: name,
            frames: scene.anims.generateFrameNames('player', {
                start: 0,
                prefix: name + '_',
                end: scene.textures.get('player').frameTotal
            }),
            frameRate: scene.fps,
            repeat: name === 'fall' ? 0 : -1
        });
    }

    /**
     * Starts the transition animation and sets the next animation in line
     *
     * @param key
     */
    nextAnimation(key) {
        this.sprite.next_animation = key;
        this.sprite.anims.play('flare', true).setScale(this.flare_scale);
    }

    /**
     * Finds the next animation based on time
     *
     * @param currentSecond
     */
    update(currentSecond) {
        if (this.marked) {
            return false;
        }

        let availableAnimation = this.animations.find(availableAnimation => {
            return availableAnimation.time === currentSecond;
        });

        if (availableAnimation) {
            this.nextAnimation(availableAnimation.animation);
        }
    }
}
